import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';

function initSwipers() {
    const swiperEl = document.querySelector('.swiper--marquee');
    
    if (!swiperEl) return;

    new Swiper(swiperEl, {
        modules: [Autoplay],

        slidesPerView: 'auto',
        // spaceBetween: 48,
        loop: true,
        speed: 6000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        breakpoints: {
            0: {
                spaceBetween: 16,
            },
            768: {
                spaceBetween: 48,
            },
        },
    });
}

document.addEventListener('DOMContentLoaded', 
    initSwipers(),
);